import Button from "./Button";

function RetryIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M21 12a9 9 0 1 1-3-6.7" />
      <path d="M21 4v6h-6" />
    </svg>
  );
}

export default function RetryBlock({
  message = "Data unavailable right now. Please try again.",
  onRetry,
}) {
  return (
    <div className="retry-block">
      <div className="state-icon retry-icon">
        <RetryIcon />
      </div>
      <span className="retry-message">{message}</span>
      <Button variant="primary" size="sm" onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
}
